import { AgendaTopicAPIData } from '../../../../types/growth-api';

export class AgendaTopicDTO {
	apiData: AgendaTopicAPIData;
	id: string;
	meetingId: string;
	categoryId: string;
	copiedFromTopicId: string | null;
	title: string;
	content: string;
	repeats: boolean;
	categoryType: string;
	createdAt: Date;
	createdByUserId: string | null;
	updatedAt: Date;
	lockedAt: Date | null;
	lockedByUserId: string | null;
	isNew = false;
	isDeleted = false;
	placeholderContent = '';
	summary = '';
	hostId: string;
	guestId: string;
	parentEntityType?: string | null;
	parentEntityId?: string | null;

	constructor(data: AgendaTopicAPIData) {
		this.apiData = data;
		this.id = data.id;
		this.meetingId = data.meeting_id;
		this.categoryId = data.category_id;
		this.copiedFromTopicId = data.copied_from_topic_id;
		this.title = data.title;
		this.content = data.content;
		this.repeats = data.repeats;
		this.createdAt = new Date(data.created_at);
		this.updatedAt = new Date(data.updated_at);
		this.createdByUserId = data.created_by_user_id;
		this.lockedAt = data.locked_at ? new Date(data.locked_at) : null;
		this.lockedByUserId = data.locked_by_user_id;
		this.placeholderContent = data.placeholder_content;
		this.summary = data.summary ?? '';
		this.hostId = data.host_id;
		this.guestId = data.guest_id;
		this.createdByUserId = data.created_by_user_id;
		this.categoryType = data.category_type;
		this.parentEntityType = data.parent_entity_type;
		this.parentEntityId = data.parent_entity_id;
	}
}
